import React from "react";
import PropTypes from "prop-types";
//limitless imports
import { useSecureData } from "../../../../expert";
import Dialog from "@limitless/modern/feedback/dialog/Dialog";
import DropdownMenu from "@limitless/modern/inputs/dropdown-menu/DropdownMenu";
const SecureDataRequestDialog = ({
  onCancel,
  t
}) => {
  const {
    selectedConfig,
    setSelectedConfig,
    configSuggestions,
    createSecureDataRequest
  } = useSecureData();
  const isFormInvalid = !selectedConfig;
  return /*#__PURE__*/React.createElement(Dialog, {
    open: true,
    onClose: () => onCancel(false),
    title: "Sensitive Data Request",
    onCancelClick: () => onCancel(false),
    onOkClick: () => {
      onCancel(false);
      createSecureDataRequest(onCancel);
    },
    okDisabled: isFormInvalid,
    okDisabledTooltip: t("Please select secure data type"),
    okText: "ok",
    paperStyle: {
      maxWidth: "470px"
    },
    cancelVariant: "text"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DropdownMenu, {
    label: "Type of data",
    required: true,
    id: "reasonCode",
    placeholder: "Type to search",
    value: selectedConfig,
    options: configSuggestions,
    onChange: (_, value) => setSelectedConfig(value)
  })));
};
SecureDataRequestDialog.propTypes = {
  onCancel: PropTypes.func,
  configOptions: PropTypes.object,
  t: PropTypes.func
};
export default SecureDataRequestDialog;